import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MuiAvatarModule, MuiIconModule } from '@move/ui';
import { MmuMainMenu } from './mmu-main-menu/mmu-main-menu.component';
import { MmuMainMenuLink } from './mmu-main-menu/mmu-main-menu-link.component';
import { MmuAnalyticsModule } from '../analytics/mmu-analytics.module';

@NgModule({
  declarations: [MmuMainMenu, MmuMainMenuLink],
  imports: [CommonModule, RouterModule, MuiIconModule, MuiAvatarModule, MmuAnalyticsModule],
  exports: [MmuMainMenu, MmuMainMenuLink]
})
export class MmuMainMenuModule {}
